// extracted by mini-css-extract-plugin
export default {"page":"pdfRenderer_page__1VRnV"};